import { dataService } from 'App';

/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */

const profileServiceUrl='/users/profile';
export function getIpList() {

  return dataService.get(
    `${profileServiceUrl}/list/ip`,
  );
}

export function getMsisdnList() {

  return dataService.get(
    `${profileServiceUrl}/list/msisdn`,
  );
}


export function removeIp(data) {

  return dataService.put(
    `${profileServiceUrl}/removeIp`, data, {}
  );
}

export function addIp(data) {

  return dataService.post(
    `${profileServiceUrl}/addIp`, data, {}
  );
}

export function removeMsisdn(data) {

  return dataService.put(
    `${profileServiceUrl}/remove`, data, {}
  );
}

export function addMsisdn(data) {

  return dataService.post(
    `${profileServiceUrl}/add`, {msisdn:data.userOtpMsisdn}, {}
  );
}